import settings from '../helpers/settings';
import {TweenLite, Power1} from 'gsap';
import ScrollMagic from 'scrollmagic';

let PinColums = function (options) {
    return {
        default: {
            triggerSelector: '#parallax-wrapper-',
            pinSelector: '.item__img-switcher',
            columnsSelector: '.parallax-item',
            useColumns: true,
            offset: -203
        },

        controller: null,
        scene: null,

        getSmallerColumn: function(arr) {
            return Array.prototype.reduce.call(arr, function (p, v) {
                return (p.offsetHeight < v.offsetHeight ? p : v);
            });
        },

        init: function () {
            this.options = _.extend(this.default, options);
            this.pinElements = document.querySelectorAll(this.options.columnsSelector);
            this.controller = new ScrollMagic.Controller();

            this.activate();
            this.onChangeHeader(this.options.offset);
        },

        onChangeHeader: function(offset){
            let obj = {y: offset};
            settings.set('onChange', function(key, old, value){
                console.log('onChange', key, old, value, obj.y);

                if (this.scene) {
                    TweenLite.to(obj, 0.5 * 60, {
                        y: offset + 75 - value,
                        ease: Power1.easeInOut,
                        useFrames: true,
                        onUpdate: function(){
                            this.scene.offset(obj.y).refresh();
                        }.bind(this)
                    });
                }
            }.bind(this));
        },

        onResize: function() {
            console.log('onResize');
            let minPinElement = this.getSmallerColumn(this.pinElements);
            let pinElement = this.options.useColumns ? minPinElement : document.querySelector(this.options.pinSelector);

            this.scene.removePin(true);
            this.scene.setPin(pinElement);
        },

        activate: function() {
            this.desactivate();
            console.log('ACTIVATE PinColums');

            let triggerElement = document.querySelector(this.options.triggerSelector);
            let minPinElement = this.getSmallerColumn(this.pinElements);
            let pinElement = this.options.useColumns ? minPinElement : document.querySelector(this.options.pinSelector);
            let offset = this.options.offset;
            let offsetInside = this.options.offsetInside || 0;

            this.scene = new ScrollMagic.Scene({
                triggerElement: triggerElement,
                triggerHook: 0,
                duration: function(h){
                    return parseInt(h - pinElement.offsetHeight - offsetInside, 10);
                }(triggerElement.offsetHeight),
                offset: offset
            })
            // .addIndicators()
            .setPin(pinElement)
            .addTo(this.controller);
        },

        desactivate: function() {
            if (this.scene) {
                console.log('DESACTIVATE PinColums');
                this.scene.destroy(true);
            }
        }
    };
};

export default PinColums;



// WEBPACK FOOTER //
// ./src/js/components/pin-columns.js